import { setComponentMapOverrides } from '@jutro/uiconfig';
import 'gw-capability-policychange-common-react';
import PCBAPolicyChange from './pages/PolicyChanges/PolicyChangePage';
import PCBAAddressPage from './pages/Address/AddressPage';
import PCBACoveragePage from './pages/Coverages/CoveragePage';
import PCBAVehiclePage from './pages/Vehicles/VehiclesPage';
import PCBADriverAssignmentPage from './pages/DriverAssignment/DriverAssignmentPage';
import PCBAQuotePage from './pages/Quote/QuotePage';
import PCBADriverPage from './pages/Drivers/DriversPage';
import PCBARiskAnalysisPage from './pages/RiskAnalysis/RiskAnalysisPage';

setComponentMapOverrides(
    {
        PCBAPolicyChange: { component: 'PCBAPolicyChange' },
        PCBAAddressPage: { component: 'PCBAAddressPage' },
        PCBAVehiclePage: { component: 'PCBAVehiclePage' },
        PCBADriverAssignmentPage: { component: 'PCBADriverAssignmentPage' },
        PCBADriverPage: { component: 'PCBADriverPage' },
        PCBACoveragePage: { component: 'PCBACoveragePage' },
        PCBAQuotePage: { component: 'PCBAQuotePage' },
        PCBARiskAnalysisPage: { component: 'PCBARiskAnalysisPage' }
    },
    {
        PCBAPolicyChange,
        PCBAAddressPage,
        PCBAVehiclePage,
        PCBADriverAssignmentPage,
        PCBADriverPage,
        PCBACoveragePage,
        PCBAQuotePage,
        PCBARiskAnalysisPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as BAPolicyChangeMessages } from './BAPolicyChange.messages';
export { default as BAPolicyChangeWizard } from './BAPolicyChangeWizard';
